import React from 'react';
import { t } from 'i18n';

import ActionButton from 'Components/Base/ActionButton';

const i18nOpts = { scope: 'registration.email_confirmation_modal' };

import resendConfirmationEmail from '../resendConfirmationEmail';

const LinkExpired = ({
  resendConfirmationEmailUrl,
  errorType,
  setErrorType,
  setStep,
  emailToken,
}) => {
  return <>
    <div className="registrationV2__email_confirmation_modal__link_expired_body">
      <h2 className="registrationV2__email_confirmation_modal__link_expired_header">
        {t('link_expired_header', i18nOpts)}
      </h2>
      <div>
        {
          errorType === 'expired'
            ? t('resend_email', i18nOpts)
            : t('link_expired_info', i18nOpts)
        }
      </div>
    </div>
    <div className="ModalV2__footer registrationV2__email_confirmation_modal__success_footer">
      <ActionButton
        content={errorType === 'expired' ? t('resend', i18nOpts) : t('start_signup', i18nOpts)}
        onClick={() => {
          if (errorType === 'expired') {
            resendConfirmationEmail(resendConfirmationEmailUrl, { emailToken });
            setErrorType(null);
            setStep('CODE_INPUT');
          } else {
            window.location.replace(window.location.href.split('?')[0]);
          }
        }}
        className="registrationV2__email_confirmation_modal__to_login"
      />
    </div>
  </>;
};

export default LinkExpired;
